<div class="country-name">
  <span *ngIf="country.excluded" class="excluded">{{ 'chart-ng-worldmap.excluded' | translate }}:</span>
  {{ countriesMap && countriesMap[country.id] ? countriesMap[country.id].name : '' }}
</div>
<div class="count">{{ 'chart-ng-worldmap.totalSignals' | translate }}: {{ country.count || 0 | formatNumber }}</div>

<ng-container *ngIf="categoryMap && country.data">
  <div class="stats">
    <div class="item" *ngFor="let item of country.data">
      <div class="item-circle-category" [ngStyle]="{ background: categoryMap[item.category].color }"></div>
      <div class="item-category">
        {{ item.category }}
      </div>

      <div class="item-value">
        {{ item.value | formatNumber }}
      </div>
    </div>
  </div>
</ng-container>
